'use client';

import { FaqSection as KeziosFaqSection } from '@kezios/design-system';
import { useTranslations } from 'next-intl';

export const FaqSection = () => {
  const t = useTranslations('section.faq');

  return (
    <KeziosFaqSection
      title={t('title')}
      subtitle={t('subtitle')}
      category={t('category')}
    >
      <KeziosFaqSection.Item
        key="faqFirst"
        value="key"
        title={t('items.first.question')}
        content={t('items.first.answer')}
      />
      <KeziosFaqSection.Item
        key="faqSecond"
        value="compatible"
        title={t('items.second.question')}
        content={t('items.second.answer')}
      />
      <KeziosFaqSection.Item
        key="faqThird"
        value="cancel"
        title={t('items.third.question')}
        content={t('items.third.answer')}
      />
    </KeziosFaqSection>
  );
};
